import { z } from 'zod'

// Validation for the manual time-entry form (create + edit). Kept in its own
// module so it can be unit-tested without pulling in the React Native dialog.
//
// notesRequired: only regular workers must justify a manual entry with a note.
// Admin and clerical staff are exempt — the dialog derives this from the
// current user's role (role === 'workforce'), not from who owns the entry.
export const buildManualEntrySchema = (notesRequired: boolean) =>
    z
        .object({
            jobId: z.string().min(1, 'Job is required'),
            locationId: z.string().optional(),
            clockIn: z.date({ message: 'Clock in time is required' }),
            clockOut: z.date({ message: 'Clock out time is required' }),
            notes: notesRequired
                ? z.string().trim().min(3, "Add a short note about what you're working on")
                : z.string().optional(),
            isBreak: z.boolean().optional(),
        })
        .refine(data => data.clockOut > data.clockIn, {
            message: 'Clock out must be after clock in',
            path: ['clockOut'],
        })

export type ManualEntryFormData = z.infer<ReturnType<typeof buildManualEntrySchema>>
